module.exports = "<iframe [src]=\"url\" class=\"asp-iframe\"></iframe>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/pregled-obracuna/pregled-obracuna.component.html
// module id = ./src/app/pages/pregled-obracuna/pregled-obracuna.component.html
// module chunks = main